<template>
    <b-container fluid>
        <b-row>
            <b-col class="col-form px-0" lg="6">
                <b-navbar class="bg-light" style="border-bottom: 1px solid #dee2e6!important;">
                    <b-navbar-brand class="mr-0">{{title}}</b-navbar-brand>
                </b-navbar>
                <slot></slot>
            </b-col>
            <b-col class="bg-secondary" lg="6"></b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "auth-layout",
        props: ['title'],
    }
</script>

<style scoped>
    .col-form {
        height: 100vh;
    }
</style>


// WEBPACK FOOTER //
// src/components/layouts/AuthLayout.vue